const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
const CONSENT_KEY = 'rs-cookie-preferences';
const CONSENT_CHANGED = 'rs-cookie-preferences-changed';

let initialized = false;

export function hasAnalyticsConsent() {
  try {
    // Global Privacy Control (GPC): treat the browser signal as an opt-out of
    // non-essential analytics regardless of any stored choice.
    if (navigator.globalPrivacyControl === true) return false;
    return JSON.parse(window.localStorage.getItem(CONSENT_KEY) || '{}').analytics === true;
  } catch {
    return false; // fail closed
  }
}

function ensureGtag() {
  if (!MEASUREMENT_ID || !hasAnalyticsConsent()) return false;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!document.querySelector(`script[data-ga4="${MEASUREMENT_ID}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
    script.dataset.ga4 = MEASUREMENT_ID;
    document.head.appendChild(script);
  }

  if (!initialized) {
    window.gtag('js', new Date());
    // Manual SPA pageviews are sent in trackPageView, so suppress the automatic one.
    window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    initialized = true;
  }
  return true;
}

export function trackPageView(location) {
  if (!ensureGtag()) return;

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${location.pathname}${location.search}${location.hash}`,
    ...(process.env.NODE_ENV === 'development' ? { debug_mode: true } : {}),
  });
}

export function subscribeToConsent(callback) {
  const handler = () => callback(hasAnalyticsConsent());
  window.addEventListener(CONSENT_CHANGED, handler);
  window.addEventListener('storage', handler); // other tabs
  return () => {
    window.removeEventListener(CONSENT_CHANGED, handler);
    window.removeEventListener('storage', handler);
  };
}

export { CONSENT_KEY, CONSENT_CHANGED };
